import type { FormEvent } from 'react';
import React from 'react';

import { FormField, Input, Label } from '@zillow/constellation';

import type { Section } from '../../../models/index';

type Props = {
  section: Section;
  setSectionValues: (keyValuePairs: object) => void;
};

function PropertyManagerWebsite({ section, setSectionValues }: Props): JSX.Element {
  function setWebsite(e: FormEvent<HTMLInputElement>): void {
    setSectionValues({ [`propertyManager_website`]: e.currentTarget.value });
  }

  return (
    <FormField
      label={<Label size="lg">What is the managing agent’s or property manager’s website?</Label>}
      control={<Input type="url" value={section.getFieldValue(`propertyManager_website`)} onChange={setWebsite} />}
    />
  );
}

export default PropertyManagerWebsite;
